import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";

import { Title, Fieldset, Field, Control, Button } from "rbx";

import { isAfter, isBefore } from "date-fns";
import EmployeeSelect from "./EmployeeSelect";
import { ourToast as toast } from "../../utils";
import { CREATE_EMPLOYEE_CERTIFICATION_MUTATION } from "../../graphql/EmployeeCertifications/EmployeeCertifications.graphql";

import EmployeeCertificationForm from "./EmployeeCertificationForm";

class CustomCertificationError extends Error {}

class AddEmployeeCertificationForm extends Component {
  state = {
    CertificationTypeRecIdRef: "",
    CertificationName: "",
    ExpirationDate: null,
    LastTestDate: null,
    Note1: "",
    EmployeeRecIdRef: this.props.EmployeeRecIdRef || ""
  };

  onChange = e => {
    const {
      target: { value, name }
    } = e;
    this.setState({ [name]: value });
  };

  render() {
    const {
      CertificationTypeRecIdRef,
      ExpirationDate,
      LastTestDate,
      Note1,
      CertificationName,
      EmployeeRecIdRef
    } = this.state;
    const { onComplete } = this.props;
    return (
      <Mutation
        mutation={CREATE_EMPLOYEE_CERTIFICATION_MUTATION}
        refetchQueries={["ALL_EMPLOYEE_CERTIFICATIONS_QUERY"]}
        variables={{
          data: {
            CertificationTypeRecIdRef: parseInt(CertificationTypeRecIdRef),
            CertificationName,
            ExpirationDate: ExpirationDate
              ? new Date(ExpirationDate).setUTCHours(13, 0, 0)
              : null,
            LastTestDate: LastTestDate
              ? new Date(ExpirationDate).setUTCHours(12, 0, 0)
              : null,
            Note1,
            EmployeeRecIdRef: parseInt(EmployeeRecIdRef)
          }
        }}
      >
        {(createCertification, { loading, error }) => (
          <form
            method="POST"
            onSubmit={async e => {
              e.preventDefault();
              try {
                if (!LastTestDate) {
                  throw new CustomCertificationError(
                    "Last Test Date cannot be blank."
                  );
                }
                if (!ExpirationDate) {
                  throw new CustomCertificationError(
                    "Expiration Date cannot be blank."
                  );
                }
                if (isBefore(new Date(LastTestDate), new Date("1753"))) {
                  throw new CustomCertificationError(
                    "Last Test Date must be after 1753 AD."
                  );
                }
                if (isAfter(new Date(LastTestDate), new Date("9999"))) {
                  throw new CustomCertificationError(
                    "Last Test Date must be before 9999 AD."
                  );
                }
                if (isBefore(new Date(ExpirationDate), new Date("1753"))) {
                  throw new CustomCertificationError(
                    "Expiration Date must be after 1753 AD."
                  );
                }
                if (isAfter(new Date(ExpirationDate), new Date("9999"))) {
                  throw new CustomCertificationError(
                    "Expiration Date must be before 9999 AD."
                  );
                }
                await createCertification();
                onComplete();
                toast.success("Certification added successfully.");
              } catch (err) {
                if (err instanceof CustomCertificationError) {
                  toast.error(err.message);
                } else {
                  toast.error("Error adding Certification.");
                }
              }
            }}
          >
            <header className="page-head">
              <div className="page-head-start">
                <Title>Add Certification</Title>
              </div>
            </header>
            <Fieldset disabled={loading}>
              {!this.props.EmployeeRecIdRef && (
                <EmployeeSelect
                  required
                  icon="globe"
                  label="Employee"
                  name="EmployeeRecIdRef"
                  value={EmployeeRecIdRef}
                  onChange={this.onChange}
                />
              )}
              <EmployeeCertificationForm
                inputs={{
                  CertificationTypeRecIdRef,
                  ExpirationDate,
                  LastTestDate,
                  Note1
                }}
                onChange={this.onChange}
              />
              <hr />
              <Field kind="group">
                <Control>
                  <Button color="primary" type="submit">
                    Submit
                  </Button>
                </Control>
                <Control>
                  <Button type="button" onClick={onComplete}>
                    Cancel
                  </Button>
                </Control>
              </Field>
            </Fieldset>
          </form>
        )}
      </Mutation>
    );
  }
}

AddEmployeeCertificationForm.propTypes = {
  EmployeeRecIdRef: PropTypes.number,
  onComplete: PropTypes.func
};
export default AddEmployeeCertificationForm;
